export const EVIDENSIA_LOGO_URL =
  'https://evidensia.se/getmedia/04a0328f-15fc-4cce-a61f-5c5b473088be/evidensia-se-1.svg?ext=.svg';

export type EvidensiaLogoProps = {
  align?: 'left' | 'right';
  size?: 'default' | 'small' | 'compact';
};
